import React from "react";
import "../cmms.css";

// Opciones como botones de color (prioridad de ticket, etc.). Compatible con FormItem.
// opciones: [{ value, label, color }] con color en hex.
const SelectorColoresCMMS = ({ value, onChange, disabled, opciones = [] }) => (
    <div className="cmms-estatus" style={{ gridTemplateColumns: `repeat(${opciones.length}, minmax(0, 1fr))` }} role="radiogroup">
        {opciones.map((o) => {
            const activo = value === o.value;
            return (
                <div
                    key={o.value}
                    role="radio"
                    aria-checked={activo}
                    tabIndex={0}
                    className={"cmms-estatus-opcion" + (activo ? " activo" : "")}
                    style={activo ? { background: o.color } : undefined}
                    onClick={() => !disabled && onChange && onChange(o.value)}
                    onKeyDown={(e) => {
                        if (!disabled && onChange && (e.key === "Enter" || e.key === " ")) {
                            e.preventDefault();
                            onChange(o.value);
                        }
                    }}
                >
                    <span className="cmms-estatus-punto" style={{ background: o.color }} />
                    {o.label}
                </div>
            );
        })}
    </div>
);

export const COLORES_PRIORIDAD = [
    { value: 1, label: "Urgente", color: "#d64545" },
    { value: 2, label: "Durante el día", color: "#d9962b" },
    { value: 3, label: "Programable", color: "#2e9e6b" },
];

export default SelectorColoresCMMS;
